import { render, staticRenderFns } from "./DynamicIcon.vue?vue&type=template&id=56ce1124"
import script from "./DynamicIcon.vue?vue&type=script&lang=js"
export * from "./DynamicIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports